import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import Input from '@components/Inputs/v2/Input';
import validationSchema from './CCPAValidationSchema';

const CCPAForm = ({ onComplete }) => {
  return (
    <div className="ccpa-form">
      <Formik
        initialValues={{
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async values => {
          onComplete(values);
        }}
      >
        {({ handleSubmit }) => (
          <Form className="form-wrap" onSubmit={handleSubmit}>
            <div className="form-field">
              <Input name="first_name" label="First Name" />
            </div>
            <div className="form-field">
              <Input name="last_name" label="Last Name" />
            </div>
            <div className="form-field">
              <Input name="email" label="Email" />
            </div>
            <div className="form-field">
              <Input
                name="phone"
                label="Phone"
                type="tel"
                mask="999-999-9999"
              />
            </div>
            <div className="additional-info">
              Please read our <a href="/privacy-policy">privacy policy</a> for additional information about your data removal request.
            </div>
            <button
              className="btn btn-lg btn-secondary mt-2"
              type="submit"
            >
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

CCPAForm.propTypes = {
  onComplete: PropTypes.func.isRequired,
};

export default CCPAForm;